import React, { useState, useEffect, useRef } from "react";
import { Loading, Title } from "react-admin";
import { CardContent, CardMedia, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getPhotoUrl } from "../../../utils/fileUtils";
import MapOutlinedIcon from "@material-ui/icons/MapOutlined";
import CrewCard from "../../../components/common/CrewCard";
import { ForceTitle } from "../../../components/common/ForceTitle";

const useStyles = makeStyles((theme) => ({
  media: {
    margin: "auto",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRadius: "6px",
    boxShadow: "010px20pxrgba(0,0,0,0.19),06px6pxrgba(0,0,0,0.23)",
  },
}));

export const Maps = (props) => {
  const record = { mapImage: window.appUser.reloadYard.mapImage };

  return (
    <>
      <Title title={<ForceTitle title="Map" />} />
      <CrewCard title="Yard Map" icon={<MapOutlinedIcon fontSize="large" />}>
        <CardContent>
          <MapContent {...props} record={record} />
        </CardContent>
      </CrewCard>
    </>
  );
};

export const MapContent = ({ record, ...props }) => {
  const classes = useStyles();
  const isComponentMounted = useRef(true);
  const photoSize = window.innerWidth < 1280 ? 1280 : window.innerWidth;

  const [loading, setLoading] = useState(true);
  const [photo, setPhoto] = useState();

  useEffect(() => {
    if (isComponentMounted) getMap();
    return () => (isComponentMounted.current = false);
  }, []);

  const getMap = () => {
    debugger;
    if (record?.mapImage) {
      const fullSizeUrl = getPhotoUrl(record.mapImage.key, photoSize);
      setPhoto(fullSizeUrl);
    } else setPhoto(null);

    setLoading(false);
  };

  if (loading) return <Loading />;
  return (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Grid item xs={12}>
        {photo ? (
          <CardMedia className={classes.media} image={photo} component="img" />
        ) : null}
      </Grid>
    </Grid>
  );
};
